"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var models_1 = require("./models");

var ChangeIndicator_1 = require("../../overview/ChangeIndicator/ChangeIndicator");

var ContextMenu_1 = __importDefault(require("../ContextMenu"));

var Actions_1 = __importDefault(require("../Actions"));

var Checkbox_1 = __importDefault(require("../Checkbox"));

var Icon_1 = __importDefault(require("../Icon"));

var MorningStar_1 = __importDefault(require("../MorningStar"));

var Link_1 = __importDefault(require("../Link"));

var Translate_1 = __importDefault(require("../Translate"));

var ToggleButton_1 = __importDefault(require("../ToggleButton"));

var Color_1 = __importDefault(require("../Color"));

var Scale_1 = __importDefault(require("../Scale"));

var WeightingBar_1 = require("../WeightingBar/WeightingBar");

var ScaleLegend_1 = __importDefault(require("../ScaleLegend"));

var isNullOrUndefined = ksys_app_template_1.utils.typeChecks.isNullOrUndefined;

var TableLogic =
/** @class */
function () {
  function TableLogic(props, globalConfiguration, translationHelper) {
    var _this = this;

    this.props = props;
    this.globalConfiguration = globalConfiguration;
    this.translationHelper = translationHelper;

    this.formatValueForColumn = function (value, column, translationContext) {
      var _a = (_this.globalConfiguration || {}).formats,
          globalFormats = _a === void 0 ? {} : _a;
      var _b = _this.props.formatsByType,
          formatsByType = _b === void 0 ? {} : _b;
      var formatType = column.formatType,
          format = column.format;
      var workingFormat = format || formatType && (formatsByType[formatType] || globalFormats[formatType]);

      if (workingFormat) {
        if (!workingFormat.locale) {
          workingFormat.locale = translationContext && translationContext.culture;
        }

        if (!workingFormat.options) {
          workingFormat.options = {};
        }

        return ksys_app_template_1.utils.formatter.formatter(workingFormat, value);
      }

      return value;
    };

    this.getCellSuperscripts = function (column, row) {
      var id = column.id;
      var _superscriptsByColumnId = row._superscriptsByColumnId;

      if (_superscriptsByColumnId && _superscriptsByColumnId[id]) {
        return _superscriptsByColumnId[id].sort(function (a, b) {
          return a === b ? 0 : a > b ? 1 : -1;
        });
      }

      return undefined;
    };

    this.getExpanderColumn = function (hasChildren) {
      var response = {
        id: '_expander',
        key: '_expander',
        hide: false,
        excludeFromNoDataCheck: true,
        placeholder: ' '
      };

      if (hasChildren) {
        response.display = {
          type: models_1.TableColumnDisplayType.expander,
          options: {
            expander: {}
          }
        };
      }

      return response;
    };

    this.getHeaderRowCount = function (columns, headerGroupsById) {
      var max = 1;

      for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
        var column = columns_1[_i];
        var headerGroupId = column.headerGroupId;
        var headerGroup = !!headerGroupId && headerGroupsById[headerGroupId];

        if (headerGroup) {
          var groupNesting = _this.getGroupNesting(headerGroup, headerGroupsById);

          max = Math.max(max, groupNesting);
        }
      }

      return max;
    };

    this.getGroupNesting = function (headerGroup, headerGroupsById, seed) {
      if (seed === void 0) {
        seed = 1;
      }

      seed++;
      var parentId = headerGroup.parentId;
      var parentHeaderGroup = !!parentId && headerGroupsById[parentId];

      if (parentHeaderGroup) {
        return _this.getGroupNesting(parentHeaderGroup, headerGroupsById, seed);
      }

      return seed;
    };

    this.loadGroupInHeadRows = function (group, headRows, headerGroupsById) {
      var index = 0;
      var parentGroupId = group.parentId;
      var parentGroup = !!parentGroupId && headerGroupsById[parentGroupId];

      if (parentGroup) {
        index = _this.loadGroupInHeadRows(parentGroup, headRows, headerGroupsById) + 1;
      }

      var row = headRows && headRows.length > index && headRows[index];

      if (row) {
        var existing = row.find(function (mapping) {
          return mapping.group && mapping.group.id === group.id;
        });

        if (existing) {
          existing.colSpan++;
        } else {
          row.push({
            group: group,
            colSpan: 1,
            rowSpan: 1,
            hasChildren: true
          });
        }
      }

      return index;
    };
  }

  TableLogic.prototype.getRawValue = function (row, column) {
    var key = column.key;
    var value = ksys_app_template_1.utils.get(row, key);

    if (value === undefined && this.translationHelper) {
      var translatedKey = this.translationHelper.translate(key);
      value = ksys_app_template_1.utils.get(row, translatedKey);
    }

    return value;
  };

  TableLogic.prototype.getValue = function (row, column, translationContext, rowComponent) {
    var _this = this;

    var value = this.getRawValue(row, column);
    var response = this.formatValueForColumn(value, column, translationContext);
    var display = this.getColumnDisplay(column);
    var type = display.type,
        _a = display.options,
        options = _a === void 0 ? {} : _a;

    if (type === models_1.TableColumnDisplayType.contextMenu && options.contextMenu) {
      response = react_1.default.createElement(ContextMenu_1.default, __assign({}, options.contextMenu, {
        payload: row
      }));
    } else if (type === models_1.TableColumnDisplayType.actions && options.actions) {
      options.actions.buttons.forEach(function (button) {
        button.payload = row;
      });
      response = react_1.default.createElement(Actions_1.default, __assign({}, options.actions));
    } else if (type === models_1.TableColumnDisplayType.checkbox && options.checkbox) {
      var onChange = function onChange(event) {
        if (options.checkbox && options.checkbox.onChange) {
          options.checkbox.onChange(row, event.target.checked);
        }
      };

      response = react_1.default.createElement(Checkbox_1.default, __assign({
        value: !!value
      }, options.checkbox, {
        onChange: onChange
      }));
    } else if (type === models_1.TableColumnDisplayType.icon && options.icon) {
      response = react_1.default.createElement(Icon_1.default, __assign({}, options.icon));
    } else if (type === models_1.TableColumnDisplayType.morningstarRating && options.morningstarRating) {
      response = react_1.default.createElement(MorningStar_1.default, __assign({}, options.morningstarRating, {
        morningStarRating: parseInt(value, 10)
      }));
    } else if (type === models_1.TableColumnDisplayType.color) {
      response = react_1.default.createElement(Color_1.default, __assign({}, options.color || {}, {
        color: value
      }));
    } else if (type === models_1.TableColumnDisplayType.scale && options.scale) {
      response = react_1.default.createElement(Scale_1.default, __assign({}, options.scale || {}, {
        value: parseInt(value, 10)
      }));
    } else if (type === models_1.TableColumnDisplayType.expander && options.expander) {
      response = react_1.default.createElement(ToggleButton_1.default, __assign({}, options.expander, {
        onChange: function onChange(active) {
          return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
              row._expanded = active;

              if (rowComponent) {
                rowComponent.toggleExpanded(active);
              }

              return [2
              /*return*/
              ];
            });
          });
        },
        active: row._expanded,
        loading: rowComponent && rowComponent.fetchingChildren
      }));
    } else if (type === models_1.TableColumnDisplayType.link && options.link) {
      var _b = options.link,
          redirect = _b.redirect,
          conditional = _b.conditional;
      var props = {};

      if (redirect) {
        var allowLink = true;

        if (conditional) {
          var conditionalHelper = new ksys_app_template_1.helpers.ConditionalHelper(conditional, this.translationHelper);
          allowLink = conditionalHelper.matches({
            row: row,
            column: column,
            value: value
          });
        }

        if (allowLink) {
          if (redirect) {
            var redirectHelper = new ksys_app_template_1.helpers.RedirectHelper(window.location.href);
            var redirectPath = redirectHelper.getRedirectPath(redirect, {
              row: row,
              column: column,
              value: value
            });
            props.href = redirectPath;
          }

          response = react_1.default.createElement(Link_1.default, __assign({}, props), react_1.default.createElement(Translate_1.default, null, response));
        }
      }

      if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(response)) {
        response = column.placeholder || this.props.placeholder;
      }
    } else if (type === models_1.TableColumnDisplayType.weightingBar && options.weightingBar) {
      var weightingBlocksConfig_1 = options.weightingBar.weightingBlocks;
      var weightingBarProps = {
        weightingBlocks: value.map(function (val, idx) {
          var weightingBlock = weightingBlocksConfig_1[idx];
          var block = {
            value: val
          };

          if (weightingBlock) {
            Object.assign(block, weightingBlock);
          }

          return block;
        })
      };
      response = react_1.default.createElement(WeightingBar_1.WeightingBar, __assign({}, weightingBarProps));
    } else {
      if (ksys_app_template_1.utils.typeChecks.isNullOrUndefined(response)) {
        response = column.placeholder || this.props.placeholder;
      } else if (type === models_1.TableColumnDisplayType.changeIndicator && options.changeIndicator) {
        var changeIndicatorProps = Object.assign({}, options.changeIndicator, {
          value: response
        });
        var directionValue = changeIndicatorProps.directionValue;

        if (directionValue && !ksys_app_template_1.utils.typeChecks.isNumber(parseInt(directionValue, 10))) {
          changeIndicatorProps.directionValue = this.getRawValue(row, {
            id: '',
            key: directionValue
          });
        }

        response = react_1.default.createElement(ChangeIndicator_1.ChangeIndicator, __assign({}, changeIndicatorProps));
      }
    }

    return response;
  };

  TableLogic.prototype.getColumnDisplay = function (column) {
    var response = {
      type: models_1.TableColumnDisplayType.raw
    };

    if (column.display) {
      response = column.display;
    } else if (column.contextMenuProps) {
      response = {
        type: models_1.TableColumnDisplayType.contextMenu,
        options: {
          contextMenu: column.contextMenuProps
        }
      };
    } else if (column.actionsProps) {
      response = {
        type: models_1.TableColumnDisplayType.actions,
        options: {
          actions: column.actionsProps
        }
      };
    } else if (column.checkboxProps) {
      response = {
        type: models_1.TableColumnDisplayType.checkbox,
        options: {
          checkbox: column.checkboxProps
        }
      };
    } else if (column.iconProps) {
      response = {
        type: models_1.TableColumnDisplayType.icon,
        options: {
          icon: column.iconProps
        }
      };
    } else if (column.changeIndicatorProps) {
      response = {
        type: models_1.TableColumnDisplayType.changeIndicator,
        options: {
          changeIndicator: column.changeIndicatorProps
        }
      };
    }

    if (!response.type || !response.options || !response.options[response.type]) {
      response = {
        type: models_1.TableColumnDisplayType.raw
      };
    }

    return response;
  };

  TableLogic.prototype.getHeaderValue = function (headerDisplay) {
    var type = headerDisplay.type,
        _a = headerDisplay.options,
        options = _a === void 0 ? {} : _a;
    var response;

    if (type === models_1.TableColumnHeaderDisplayType.scaleLegend && options.scaleLegend) {
      response = react_1.default.createElement(ScaleLegend_1.default, __assign({}, options.scaleLegend));
    } else if (type === models_1.TableColumnHeaderDisplayType.weightingBar && options.weightingBar) {
      response = react_1.default.createElement(WeightingBar_1.WeightingBar, __assign({}, options.weightingBar));
    }

    return response;
  };

  Object.defineProperty(TableLogic.prototype, "emptyColumnIds", {
    get: function get() {
      var response = [];
      var _a = this.props,
          columns = _a.columns,
          rows = _a.rows;

      if (columns && rows) {
        for (var _i = 0, _b = columns.filter(function (column) {
          return !column.hide;
        }); _i < _b.length; _i++) {
          var column = _b[_i];
          var columnHasData = false;

          for (var _c = 0, rows_1 = rows; _c < rows_1.length; _c++) {
            var row = rows_1[_c];
            var value = this.getRawValue(row, column);

            if (!ksys_app_template_1.utils.typeChecks.isNullOrUndefined(value)) {
              columnHasData = true;
              break;
            }
          }

          if (!columnHasData) {
            response.push(column.id);
          }
        }
      }

      return response;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TableLogic.prototype, "visibleColumns", {
    get: function get() {
      var _a = this.props,
          columns = _a.columns,
          excludeEmptyColumns = _a.excludeEmptyColumns;
      var emptyColumnIds = this.emptyColumnIds;
      return (columns || []).filter(function (column) {
        var id = column.id,
            hide = column.hide;
        return !hide && (!excludeEmptyColumns || !emptyColumnIds.includes(id));
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TableLogic.prototype, "headerColumns", {
    get: function get() {
      var columns = __spreadArrays(this.visibleColumns);

      if (this.props && this.props.grouping) {
        columns.unshift(this.getExpanderColumn(false));
      }

      return columns;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TableLogic.prototype, "defaultHeaderGroup", {
    get: function get() {
      return {
        id: '_defaultHeaderGroup',
        header: ''
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(TableLogic.prototype, "headerMapping", {
    get: function get() {
      var headRows = [];
      var columns = this.headerColumns;
      var headerGroups = this.props.headerGroups;
      var headerGroupsById = ksys_app_template_1.utils.collection.pivotCollection(headerGroups || [], function (value) {
        return value.id;
      });
      var headerRowCount = this.getHeaderRowCount(columns, headerGroupsById);

      for (var counter = 0; counter < headerRowCount; counter++) {
        headRows.push([]);
      }

      for (var columnIndex = 0; columnIndex < columns.length; columnIndex++) {
        var column = columns[columnIndex];
        var headerGroupId = column.headerGroupId;
        var headerGroup = !!headerGroupId && headerGroupsById[headerGroupId];

        if (!headerGroup) {
          headRows[0].push({
            column: column,
            columnIndex: columnIndex,
            colSpan: 1,
            rowSpan: 1,
            hasChildren: false
          });
        } else {
          var parentIndex = this.loadGroupInHeadRows(headerGroup, headRows, headerGroupsById);
          var rowIndex = parentIndex + 1;
          var row = headRows && headRows.length > rowIndex && headRows[rowIndex];

          if (row) {
            row.push({
              column: column,
              columnIndex: columnIndex,
              colSpan: 1,
              rowSpan: 1,
              hasChildren: false
            });
          }
        }
      }

      for (var index = 0; index < headRows.length; index++) {
        var row = headRows[index];
        var remainingRowCount = headRows.length - index;

        for (var _i = 0, row_1 = row; _i < row_1.length; _i++) {
          var mapping = row_1[_i];

          if (!mapping.hasChildren) {
            mapping.rowSpan = remainingRowCount;
          }
        }
      }

      return headRows;
    },
    enumerable: true,
    configurable: true
  });
  return TableLogic;
}();

exports.TableLogic = TableLogic;